import { Tabs, Input, Select } from "antd";
import e1 from "../../../../imgs/e1.png";
import e2 from "../../../../imgs/e2.png";
import e3 from "../../../../imgs/e3.png";
import e4 from "../../../../imgs/e4.png";
import back5 from "../../../../imgs/back5.png";
import { useNavigate } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import Page from "../../Listing/page";
const Listingb = () => {
  const router = useNavigate();
  const items = [
    {
      key: "1",
      label: `All`,
      children: <Page />,
    },
    {
      key: "2",
      label: `Active`,
      children: <Page />,
    },
    {
      key: "3",
      label: `Pending`,
      children: <Page />,
    },
  ];

  return (
    <div className="p-10 pl-[5rem] pr-[5rem]">
      <div>
        <div className="relative flex justify-between items-center ">
          <div
            onClick={() => router("/EDashboard/PensionL")}
            className="absolute top-[2.8] cursor-pointer left-[-3.5%]"
          >
            <img className="w-[1.7rem]" src={back5} alt="" />
          </div>
          <h2 className="font-bold text-[1.8rem]">Beneficiaries</h2>
        </div>
        <div className="flex w-full justify-between mt-[3rem] mb-8">
          <div className="w-[13rem] h-[4.5rem] bg-[#E8E8E8] rounded-md p-3 flex justify-between">
            <div>
              <h2 className="text-[0.8rem] font-semibold text-[#797979]">
                Total Beneficiaries
              </h2>
              <p className="font-bold text-[1.4rem] ml-1">8</p>
            </div>
            <div>
              <img className="w-[2.1rem] mt-4" src={e2} alt="" />
            </div>
          </div>
          <div className="w-[13rem] h-[4.5rem] bg-[#E8E8E8] rounded-md p-3 flex justify-between">
            <div>
              <h2 className="text-[0.8rem] font-semibold text-[#797979]">
                Active Beneficiaries
              </h2>
              <p className="font-bold text-[1.4rem] ml-1">5</p>
            </div>
            <div>
              <img className="w-[2.2rem] mt-4" src={e3} alt="" />
            </div>
          </div>
          <div className="w-[13rem] h-[4.5rem] bg-[#E8E8E8] rounded-md p-3 flex justify-between">
            <div>
              <h2 className="text-[0.8rem] font-semibold text-[#797979]">
                Inactive Beneficiaries
              </h2>
              <p className="font-bold text-[1.4rem] ml-1">4</p>
            </div>
            <div>
              <img className="w-[2rem] mt-5" src={e1} alt="" />
            </div>
          </div>
          <div className="w-[13rem] h-[4.5rem] bg-[#E8E8E8] rounded-md p-3 flex justify-between">
            <div>
              <h2 className="text-[0.8rem] font-semibold text-[#797979]">
                Pension
              </h2>
              <p className="font-bold text-[1.4rem] ml-1">$600</p>
            </div>
            <div>
              <img className="w-[2.5rem] mt-4" src={e4} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="relative">
        <Tabs defaultActiveKey="1" items={items} />
        <div className="absolute top-1 right-0 w-[55%] flex justify-between">
          <Input
            size="large"
            placeholder="Search by name"
            prefix={<SearchOutlined />}
            className="Search"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Listingb;
